module.exports = __webpack_public_path__ + "img/logo-fav.6e98406a.png";